// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"8a9941a8","401":"4c390d10","554":"8de81095","580":"4854e25c","596":"bdd94809"}[chunkId] + ".chunk.js";
};